import { Injectable } from '@angular/core';
import { Observable, of, PartialObserver, Subscription } from 'rxjs';
import { DivisionRole, OrganizationLink, User } from './security.dto';
import { UserRolesProviderService } from './user-roles-provider.service';
import { Division, OrganizationInfos } from '@damofire/data-stas';

@Injectable()
export class AuthenticationService extends UserRolesProviderService {
  isAuthenticated(): Promise<boolean> {
    return Promise.resolve(false);
  }

  isAuthenticated$(): Observable<boolean> {
    return of(false);
  }

  subscribe(observer: PartialObserver<any>): Subscription {
    return null;
  }

  currentUser(): Promise<User> {
    return null;
  }

  login(email: string, password: string): Promise<boolean> {
    return null;
  }

  logout(): void {
    // Empty
  }

  reset(): void {
    // Empty
  }

  renewSession(): Promise<void> {
    return Promise.resolve();
  }

  roles(): Promise<string[]> {
    return Promise.resolve([]);
  }

  hasRole(role: string): Promise<boolean> {
    return Promise.resolve(false);
  }

  administrating(): OrganizationLink[] {
    return [];
  }

  divisions(): Promise<DivisionRole[]> {
    return Promise.resolve([]);
  }

  isDivisionRep(divisionId: string): boolean {
    return false;
  }

  canAddUser(organizationId: string, divisionId?: string): Promise<boolean> {
    return Promise.resolve(false);
  }

  canEditOrg(organizationId: string): Promise<boolean> {
    return Promise.resolve(false);
  }

  canEditDivision(organizationInfos: Division | OrganizationInfos): Promise<boolean> {
    return Promise.resolve(false);
  }

  async authenticationLock(): Promise<void> {
    return Promise.resolve();
  }
}
